<template>
  <div id="map" />
</template>

<script>
import mapboxgl from 'mapbox-gl'
import axios from '@axios'

export default {
  data() {
    return {
      apiUrl: 'https://web-api.firsttech.co.th/getLineCount-PNC',
      rtsp: [],
      name: [],
      center: [],
      mapLoaded: false,
      intervalId: null,
    }
  },
  mounted() {
    this.getMarkerAnalytic()
    this.intervalId = setInterval(() => {
      if (!this.mapLoaded) {
        this.loadMapboxGL()
          .then(() => {
            this.initializeMap()
          })
          .catch(error => {
            console.error('Mapbox GL JS failed to load:', error)
          })
      } else {
        clearInterval(this.intervalId)
      }
    }, 1000)
  },
  methods: {
    getMarkerAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getMarkerAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.markers = response.data
            this.rtspData = []
            this.rtsp = []
            this.coordinates = []
            this.rtspData = response.data
            this.rtspData.forEach(value => {
              this.rtsp.push(value.RTSP_URL)
              this.name.push(value.Camera_Desc)
              this.coordinates.push([value.Longitude, value.Latitude])
            })
            console.log(5522, this.coordinates)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getMarkerAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.markers = response.data
            this.rtspData = []
            this.rtsp = []
            this.coordinates = []
            this.rtspData = response.data
            this.rtspData.forEach(value => {
              this.rtsp.push(value.RTSP_URL)
              this.name.push(value.Camera_Desc)
              this.coordinates.push([value.Longitude, value.Latitude])
            })
            console.log(5522, this.coordinates)
          })
          .catch(error => {
            console.log(error)
          })
      }
      axios
        .post('/getWayAIDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.center.push(response.data[0].longitude)
          this.center.push(response.data[0].latitude)
        })
        .catch(error => {
          console.log(error)
        })
    },

    async fetchLineCount() {
      try {
        const response = await axios.post('https://web-api.firsttech.co.th/cctv-sum_KT')
        return response.data
      } catch (error) {
        console.error('Error fetching data:', error)
        return []
      }
    },
    async initializeMap() {
      mapboxgl.accessToken = 'pk.eyJ1IjoiYnJlbmRlcjk5IiwiYSI6ImNsdTViZTk0YjFudGoya20yb3I0Mjh6NzEifQ.X6OzGtKAj-aLUJ0hQvt6Rw'

      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/brender99/cm0kt3adp006r01pbbmxp2nh3',
        center: [this.center[0] - (-0.03113), this.center[1]],
        zoom: 12,
        pitch: 68,
        bearing: -20,
        logoPosition: 'top-left',
        attributionControl: false,
      })

      const data = await this.fetchLineCount()
      this.map.on('load', () => {
        this.addTrafficLayer(data)
        this.addCCTVMarkers()
      })
    },
    addTrafficLayer(data) {
      if (!data || data.length === 0) {
        console.warn('No traffic data available.')
        return
      }

      this.map.addLayer({
        id: 'traffic',
        type: 'line',
        source: {
          type: 'vector',
          url: 'mapbox://mapbox.mapbox-traffic-v1',
        },
        'source-layer': 'traffic',
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': [
            'case',
            ['==', ['get', 'congestion'], 'low'], '#073581',
            ['==', ['get', 'congestion'], 'moderate'], '#073581',
            ['==', ['get', 'congestion'], 'heavy'], '#FF0000',
            ['==', ['get', 'congestion'], 'severe'], '#b71c1c',
            '#56c8d8', // Default color
          ],
          'line-width': [
            'interpolate', ['linear'], ['zoom'],
            5, 1,
            22, 10,
          ],
          'line-opacity': 0.75,
        },
      })
    },
    addCCTVMarkers() {
      // const cctvLocations = [
      //   {
      //     coordinates: [100.530323, 13.746192],
      //     title: 'CCTV1 Left',
      //     url: 'https://drr-trg5036-industrial01.enixma.net/live/10.56.1.1.stream/playlist.m3u8',
      //   },
      //   {
      //     coordinates: [100.531117, 13.746274],
      //     title: 'CCTV2 Right',
      //     url: 'https://drr-trg5036-industrial01.enixma.net/live/10.56.1.2.stream/playlist.m3u8',
      //   },
      // ]
      const cctvLocations = this.rtsp.map((url, index) => ({
        coordinates: this.coordinates[index], // Example coordinates; adjust as necessary
        title: `CCTV ${index + 1}`,
        subtitle: this.name[index],
        url,
      }))
      console.log(cctvLocations)

      // src\assets\images\icons\cctv1.png

      cctvLocations.forEach((location, index) => {
        const el = document.createElement('div')
        // eslint-disable-next-line global-require
        const imageUrl = require('@/assets/images/icons/cctv1.png')
        el.className = 'marker'
        el.style.backgroundImage = `url('${imageUrl}')`
        el.style.width = '60px'
        el.style.height = '60px'
        el.style.backgroundSize = 'contain'
        el.style.zIndex = '0'
        el.style.backgroundRepeat = 'no-repeat'

        const popupContent = `
          <div>
            <h3 class="camera-name">${location.subtitle}</h3>
            <div class="video-container" style="width: 300px; height: 200px; margin-bottom: 20px;">
              <video id="video-${index}" class="video-js vjs-big-play-centered"
                     controls preload="auto" style="width: 100%; height: 100%;">
              </video>
            </div>
          </div>`

        const popup = new mapboxgl.Popup({ offset: 25, maxWidth: '320px' }).setHTML(popupContent)

        new mapboxgl.Marker(el)
          .setLngLat(location.coordinates)
          .setPopup(popup)
          .addTo(this.map)

        popup.on('open', () => {
          // eslint-disable-next-line no-undef
          const player = videojs(`video-${index}`, {
            fluid: true,
            aspectRatio: '16:9',
          })
          player.src({
            src: location.url,
            type: 'application/x-mpegURL',
          })
          player.play().catch(error => {
            console.error('Error playing video:', error)
          })
        })
      })
    },
    loadMapboxGL() {
      return new Promise((resolve, reject) => {
        this.mapLoaded = true
        const link = document.createElement('link')
        link.href = 'https://api.mapbox.com/mapbox-gl-js/v3.2.0/mapbox-gl.css'
        link.rel = 'stylesheet'
        document.head.appendChild(link)

        const script = document.createElement('script')
        script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.2.0/mapbox-gl.js'
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Failed to load Mapbox GL JS'))
        document.head.appendChild(script)
      })
    },

    getWayAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getWayAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.zoom = response.data[0].mapzoom
            this.deptid = response.data[0].deptid
            this.center = []
            this.center.push(response.data[0].latitude)
            this.center.push(response.data[0].longitude)
            this.waydetail = response.data[0].detail
            this.type_name = response.data[0].type_name
            this.live = response.data[0].desktop_screen
            this.anydesk = `anydesk:${1798885008}`
            this.anydesk1 = response.data[0].anydesk
            this.itvdesk = response.data[0].itvdesk_license_req
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getWayAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.zoom = response.data[0].mapzoom
            // this.deptid = response.data[0].deptid
            this.center = []
            this.center.push(response.data[0].latitude)
            this.center.push(response.data[0].longitude)
            // this.waydetail = response.data[0].detail
            // this.type_name = response.data[0].type_name
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    getCamAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCamAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.rtsp = response.data
            this.namecam = response.data[0].Camera_Desc
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCamAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.rtsp = response.data
            this.namecam = response.data[0].Camera_Desc
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style lang="scss">
.marker {
  width: 30px;
  height: 30px;
  background-size: cover;
}
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: Arial, sans-serif;
}
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 103%;
  height: 900px;
}
.mapboxgl-popup-content {
  background: rgba(0, 0, 0, 0.6);
}

.camera-name {
  color: white;
  text-align: center;
  margin-bottom: 10px;
  font-size: 14px;
  // font-weight: bold;
}
</style>
